
import {defineComponent} from 'vue';

export default defineComponent({
  props: {
    title: {
      type: String,
      required: true,
    },
    mapType: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    query: '',
  }),
});
